import React, { Component } from 'react';
import {
    Card,
    Typography,
    Button,
    Divider,
} from 'antd';
import AdminCreateBookingModal from '../../components/modals/AdminCreateBookingModal';


const { Paragraph } = Typography;

class Overview extends Component {
    state = {
        showModal: false,
    };

    handleShowModal = () => {
        this.setState({ showModal: true });
    }

    handleCloseModal = () => {
        this.setState({ showModal: false });
    }

    render() {
        const { showModal } = this.state;

        return (
            <>
                <Card title="Overview">
                    <Paragraph strong>
                        Welcome to your Dashboard
                    </Paragraph>
                    <Paragraph>
                        Here you can create manual bookings, view upcoming bookings and manage holiday.
                    </Paragraph>
                    <Divider />
                    <Button type="primary" icon="plus" onClick={this.handleShowModal}>
                        Create Booking
                    </Button>
                </Card>
                <AdminCreateBookingModal
                    visible={showModal}
                    handleCancel={this.handleCloseModal}
                />
            </>
        );
    }
}

export default Overview;
